import {toast} from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
import {Loader, Placeholder} from "rsuite";
import {useEffect, useState} from 'react';
import AuthService from "../../../services/auth.service";
import axios from "axios";
import './userMeal.scss';
import {Swiper, SwiperSlide} from "swiper/react";
import {Navigation} from "swiper";
import ArrowLeftLineIcon from '@rsuite/icons/ArrowLeftLine';
import InfoRoundIcon from '@rsuite/icons/InfoRound';
import 'swiper/css';
import "swiper/css/navigation";
import AddToHomeScreen from "../../AddToHomeScreen/AddToHomeScreen";
import UserFormUpdate from "../elements/user_form_update/userFormUpdate";
import documentIcon from "../../../img/document.png";
import Meals from '../elements/meals/meals';
//Todo change into separated component
import UserService from '../../../services/user.service';

const APP_URL = process.env.APP_URL;

const UserMeal = (props) => {
    const [isLoading, setIsLoading] = useState(false);
    const [data, setData] = useState(null);
    const [activeDate, setActiveDate] = useState(null);
    const [todayIndex, setTodayIndex] = useState(0);
    const [activeDateContent, setActiveDateContent] = useState(null);
    //const {subscriptionId, periodId, isExpired} = props;
    const {subscriptionId, periodId} = props;
    const [swiper, swiperSet] = useState(null);
    const [isExpired, setIsExpired] = useState(false);

    useEffect(() => {
        localStorage.setItem('activeIndex', '');
        sync();
    }, []);

    return (<>
        <div className="d-flex">
            <div className="w-50 text-bold text-start" style={{fontSize: '1rem', textAlign: 'start'}}>
                برنامه غذایی این دوره
            </div>
        </div>

        <div className="user-meals dates-container" style={{marginTop: '2rem'}}>
            <div className="dates">

            </div>

            <div className="date-content">
                <div className="card">
                    {data ? render() : (<>
                        <Loader backdrop content="درحال دریافت اطلاعات ..." vertical/></>)}
                </div>
            </div>
        </div>
    </>);

    function render() {
        if (data.length === 0) {
            return (<>
                <div className="empty-data">
                    <Placeholder.Paragraph rows={8}/>
                    <Loader backdrop content="سیستم درحال پردازش اطلاعات شما میباشد ..." vertical/>
                </div>
            </>);
        }

        if (data.day_meals.length === 0) {
            window.location.replace('/subscriptions');
            return <></>
        }

        // if (!AuthService.getSubscription().is_user_form_update) {
        //     return <UserFormUpdate/>;
        // }

        return (<>
                <div className="dates">
                    <Swiper
                        spaceBetween={0}
                        slidesPerView={4}
                        navigation={true}
                        initialSlide={activeDate ? activeDate : 0}
                        modules={[Navigation]}
                        onSwiper={(swiper)=>swiperSet(swiper)}
                        breakpoints={{
                            640: {
                                slidesPerView: 2,
                            },
                            768: {
                                slidesPerView: 4,
                            },
                            1024: {
                                slidesPerView: 7,
                            },
                        }}
                    >
                        {data.day_meals.map((dayMeal, dayMealIndex) => <SwiperSlide key={dayMealIndex}>
                            <div
                                onClick={e => changeDay(dayMealIndex)}
                                className={`day ${dayMealIndex === activeDate ? 'day-active' : ''}`}>
                                <div className="day-container">
                                    <div className="day-title">{dayMeal.date.day_title}</div>
                                    <div className="day-number">
                                        <div className="month-title">{dayMeal.date.md}</div>
                                    </div>
                                </div>
                                {dayMeal.trial ? <div className="day-trial"></div> : ''}
                            </div>
                        </SwiperSlide>)}
                    </Swiper>
                </div>

                <div className="meal-content">
                    <div className="d-block text-right" style={{marginBottom: '1rem'}}>

                        <div className="text-bold d-inline meals-day">
                            <span> وعده های </span>
                            <span
                                style={{display: activeDateContent.date.md == 'امروز' ? 'none' : 'unset'}}>{activeDateContent.date.day_title}</span> {activeDateContent.date.md}
                        </div>
                        {activeDate != todayIndex ? (<button
                            onClick={e => changeDay(todayIndex)}
                            className="btn-today">
                            مشاهده امروز
                            <ArrowLeftLineIcon/>
                        </button>) : ''}
                        {activeDateContent && activeDateContent.calorie > 0 ? (
                            <div className="d-flex d-block-on-mobile mt-10px">
                                <div className="w-50 text-start w-100-on-mobile"
                                     style={{fontSize: '1rem', textAlign: 'start'}}>
                                    <div className="total-calories">
                                        <InfoRoundIcon/>
                                        مجموع کالری دریافتی روزانه:
                                        <strong>
                                            {activeDateContent.calorie} کالری
                                        </strong>
                                    </div>
                                </div>
                            </div>) : ''}

                    </div>

                    {
                        isLoading ?
                            (<><Loader style={{marginTop: '2rem'}} size="sm" content=""/></>)
                            :
                            (<Meals
                                    mealsItems={activeDateContent.trial ? data.day_meals[0].meals : activeDateContent.meals}
                                    // activeUserSubscription={AuthService.getUser().subscription}
                                    isExpired={isExpired}
                                    data={data}
                                    activeDate={activeDate}
                                    sync={sync}
                                    trial={activeDateContent.trial}
                                    changeDay={changeDay}
                                />
                            )

                    }
                </div>


                {/* //Todo fixed it's bug change into separated component  */}
                <div style={{
                    margin: '0.5rem 0',

                }}>
                    <div>
                        <button onClick={downloadPdfGuide} className="btn_support_pdf">
                            <img src={documentIcon} style={{width: '22px', margin: '0 0.3rem'}} alt="download file"/>
                            دانلود فایل نکات مهم رژیم
                        </button>
                    </div>
                </div>


            </>

        );
    }

    function changeDay(dayIndex) {
        setIsLoading(true);
        setActiveDate(dayIndex);
        setActiveDateContent(data.day_meals[dayIndex]);
        localStorage.setItem('activeIndex', JSON.stringify(dayIndex));
        setTimeout(() => {
            setIsLoading(false);
        }, 1000);
        if(dayIndex==todayIndex) {
            swiper.slideTo(dayIndex);
        }
    }


    function sync() {

        let config = {
            headers: {
                Authorization: `Bearer ${AuthService.getAccessToken()}`,
                channel: sessionStorage.getItem('channel')

            }
        };

        config.params = {
            subscription_id: subscriptionId,
            period_id: periodId,
        };

        setIsLoading(true);
        const channel = sessionStorage.getItem('channel')

        axios.get(`${APP_URL}/api/user-meals`, config)
            .then(function (response) {


                if (response.data.data.length === 0) {
                    setData([]);
                    return false;
                }
                // if (empty(response.data.data?.day_meals)) {
                //     window.location.replace('/subscriptions')
                // }

                if (response.data.data?.is_expired_period === true ) {
                    setIsExpired(true);
                }

                let todayIndexe = response.data.data.day_meals.findIndex(day => day.today);

                setData(response.data.data);
                setTimeout(() => {
                    setIsLoading(false);
                }, 1000);

                let activeIndex = localStorage.getItem('activeIndex');

                if (todayIndexe >= 0 && activeIndex === '') {

                    setActiveDate(todayIndexe);
                    setTodayIndex(todayIndexe);
                    setActiveDateContent(response.data.data.day_meals[todayIndexe]);
                } else {
                    activeIndex ? '' : setActiveDate(todayIndex);
                    activeIndex ? '' : setTodayIndex(todayIndex);
                    activeIndex ? setActiveDateContent(response.data.data.day_meals[activeIndex]) : setActiveDateContent(response.data.data.day_meals[todayIndex]);
                }

                setIsLoading(false);

            })
            .catch(function (error) {
                console.log(error);
                setIsLoading(false);

                if (!error.response) {
                    handleNotfound();

                    return false;
                }

                const statusCode = error.response.status;
                switch (statusCode) {
                    case 422:
                        const {errors} = error.response.data;

                        for (const errorsKey in errors) {
                            const error = errors[errorsKey][0];

                            toast.error(error, {
                                position: "top-right",
                                autoClose: 5000,
                                hideProgressBar: false,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: true,
                                progress: undefined,
                                theme: "light",
                            });
                        }
                        break;

                    case 401:
                        AuthService.logout();
                        window.location.replace('/');
                        break;
                    default:
                        handleNotfound();

                        break;
                }
            });
    }

    function handleNotfound() {

        localStorage.setItem("error", 'PageNotFound');
        setIsLoading(false);
        //setStep('notfound');
        window.location.href = '';
    }

//Todo fixed bug and move  into separated component
    async function downloadPdfGuide() {

        let config = {
            headers: {Authorization: `Bearer ${AuthService.getAccessToken()}`},
            responseType: 'blob',
        };
        config.params = {
            ...{responseType: 'blob'}
        };
        await axios.get(`${APP_URL}/api/downloads/support/pdf?support.pdf`, config)
            .then(function (response) {

                if (response?.data?.size < 100) {
                    toast.error('فایل پیدا نشد', {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "light",
                    });
                    return false;
                } else {
                    const blob = new Blob([response.data], {type: "application/pdf"});
                    let pdfURL = window.URL.createObjectURL(blob);
                    let tempLink = document.createElement('a');
                    tempLink.href = pdfURL;
                    tempLink.setAttribute('download', 'فایل_پشتیبان_چنگال.pdf');
                    tempLink.click();
                }

            })
            .catch(function (error) {
                    console.log(error);

                }
            );

    }
}

export default UserMeal;
